module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isUserGuide && _vm.showGuide) ? _c('div', {
    staticClass: "lxm-dashboard-user-guide"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "lxm-dashboard-user-guide_btns lxm-dashboard-user-guide_btns_first"
  }, _vm._l((_vm.guideItems1), function(item) {
    return _c('guide-item', {
      attrs: {
        "image": item.image,
        "name": item.name,
        "href": item.href
      }
    })
  })), _vm._v(" "), _c('div', {
    staticClass: "lxm-dashboard-user-guide_btns"
  }, _vm._l((_vm.guideItems2), function(item) {
    return _c('guide-item', {
      attrs: {
        "image": item.image,
        "name": item.name,
        "href": item.href
      }
    })
  })), _vm._v(" "), _vm._m(2)]) : _c('div', {
    staticClass: "lxm-dashboard-home page"
  }, [_c('reg-source-tip'), _vm._v(" "), _c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("最近七天")]), _vm._v(" "), _c('lxm-stat', {
    staticClass: "lxm-dashboard-home__stat",
    attrs: {
      "stats": _vm.stats
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("新鲜事")]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "lxm-content-transition",
      "mode": "out-in"
    }
  }, [(_vm.showGuide) ? _c('guide') : _vm._e()], 1), _vm._v(" "), (!_vm.showGuide) ? [_c('div', [_c('transition-group', {
    attrs: {
      "name": "lxm-content-transition",
      "tag": "div",
      "mode": "out-in"
    }
  }, _vm._l((_vm.news), function(n) {
    return _c('news-item', {
      key: n,
      attrs: {
        "title": n.title,
        "data": n.data,
        "dateTime": n.dateTime
      }
    })
  }))], 1), _vm._v(" "), (_vm.hasMore) ? _c('lxm-more', {
    attrs: {
      "loading": _vm.loading,
      "pureLoading": true
    },
    on: {
      "click": _vm.moreClicked
    }
  }) : _vm._e()] : _vm._e()], 2), _vm._v(" "), (!_vm.showGuide && !_vm.isUserGuide) ? [_c('lxm-cover', {
    attrs: {
      "doCover": _vm.doCover
    }
  })] : _vm._e()], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lxm-dashboard-user-guide_logo"
  }, [_c('img', {
    attrs: {
      "src": "https://s.lingxi360.com/register/%E7%BC%96%E7%BB%84%402x.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lxm-dashboard-user-guide_tip"
  }, [_c('p', {
    staticClass: "lxm-dashboard-user-guide_tip-one"
  }, [_vm._v("灵析手机端仅提供查询等操作")]), _vm._v(" "), _c('p', {
    staticClass: "lxm-dashboard-user-guide_tip-two"
  }, [_vm._v("请登录灵析电脑端，使用更多功能")]), _vm._v(" "), _c('p', {
    staticClass: "lxm-dashboard-user-guide_tip-three"
  }, [_vm._v("电脑端地址：www.lingxi360.com")]), _vm._v(" "), _c('p', {
    staticClass: "lxm-dashboard-user-guide_tip-four"
  }, [_vm._v("如果您目前不方便登录灵析电脑端")]), _vm._v(" "), _c('p', {
    staticClass: "lxm-dashboard-user-guide_tip-five"
  }, [_vm._v("可以先点击查看以下功能哦")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lxm-dashboard-user-guide_gift"
  }, [_vm._v("\n      登录有礼：24 小时内登陆灵析电脑端，可领取 "), _c('span', [_vm._v("20元优惠券")]), _vm._v(" 和 "), _c('span', [_vm._v("新手大礼包")]), _vm._v(" 哦。快去登录吧～\n      "), _c('img', {
    attrs: {
      "src": "https://s.lingxi360.com/register/mweb_hu.png"
    }
  })])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-32cc0de3", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-32cc0de3!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Main/Dashboard/index.vue
// module id = 833
// module chunks = 0